<template>
  <form @submit.prevent="submitLang">
    <div class="dropdown">
      <button
        :class="btnstyle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false">
        <font-awesome-icon icon="fa-solid fa-language" />
        {{ $t('userConf.selectTitle') }}
      </button>
      <ul class="dropdown-menu">
        <li><a class="dropdown-item" href="#" @click.prevent="loadLanguage('ru')">
          🇷🇺 {{ $t('userConf.ru') }}</a></li>
        <li><a class="dropdown-item" href="#" @click.prevent="loadLanguage('en')">
          🇺🇸 {{ $t('userConf.eng') }}</a></li>
        <li><a class="dropdown-item" href="#" @click.prevent="loadLanguage('esp')">
          🇪🇸 {{ $t('userConf.esp') }}</a></li>
        <li><a class="dropdown-item" href="#" @click.prevent="loadLanguage('ch')">
          🇨🇳 {{ $t('userConf.ch') }}</a></li>
      </ul>
    </div>
  </form>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { useUserStore } from '../../stores/userStore';
import { getLocale } from '../../api/api';

export default {
  name: 'userLang',
  props: ['btnstyle'],
  setup() {
    const userStore = useUserStore();
    const { locale, setLocaleMessage } = useI18n();

    const loadLanguage = async (lang) => {
      if (userStore.localeMessages[lang]) {
        setLocaleMessage(lang, userStore.localeMessages[lang]);
        locale.value = lang;
        userStore.setLanguage(lang);
        return;
      }

      try {
        const messages = await getLocale(lang);
        setLocaleMessage(lang, messages);
        locale.value = lang;
        userStore.setLanguage(lang);
        userStore.localeMessages[lang] = messages;
        userStore.setLocaleMessages(lang, messages);
      } catch (err) {
        console.error(`Failed to load language "${lang}":`, err);
      }
    };

    return {
      loadLanguage,
    };
  },
};
</script>
